import { render, staticRenderFns } from "./SaleProductDetails.vue?vue&type=template&id=6697bbf0&"
import script from "./SaleProductDetails.vue?vue&type=script&lang=js&"
export * from "./SaleProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports